module.exports = __webpack_public_path__ + "static/media/error.f700a163.svg";